import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/Icon/Icon';
import styles from './SubtitlesViewTabs.module.scss';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import cx from 'classnames';
import SwitchList from '../../../../components/SwitchList/SwitchList';
import { MEDIA_TYPES } from '../../../../constants/clipsConstants';

const SubtitlesViewTabs = ({ listMode, setListMode }) => {

        const { t } = useTranslation();
        const [eyeHover, setEyeHover] = React.useState(false);

        return <div className={styles.tabsList}>
                <button className={cx(styles.tabItem, styles.withIcon, { [styles.active]: !listMode })} onClick={() => setListMode(null)}>{t('subtitles.editor.tags.final')}<Icon src='eye' className={styles.eyeIcon} onMouseOver={() => setEyeHover(true)} onMouseOut={() => setEyeHover(false)} aria-label={t('subtitles.editor.tags.final')} /></button>
                <SwitchList options={Object.entries(MEDIA_TYPES)} activeKey={listMode} onSelect={setListMode} />
                {<Tooltip text={t('subtitles.editor.tags.final.tooltip')} isHover={eyeHover} />}
        </div>
}

export default SubtitlesViewTabs;